import {initializeApp} from 'firebase/app';
import {deleteToken, getMessaging, getToken, isSupported} from 'firebase/messaging';

import {logger} from 'utils';

const config = {
    apiKey: 'AIzaSyDJSqr6_B5lZ6zMWXtYz9QC7ARvn1DR2wE',
    authDomain: 'eazyshow-agent-app.firebaseapp.com',
    projectId: 'eazyshow-agent-app',
    storageBucket: 'eazyshow-agent-app.firebasestorage.app',
    messagingSenderId: '419246950956',
    appId: '1:419246950956:web:8e17126c4fb34d071b5f89',
    measurementId: 'G-DB9PQKX18Y'
};

const vapidKey = 'BH0W72v7FOcVo6VrqtC6hg5zaTFAVf1VIplCTmSRB18MSosg5sYe5ef1smAesva4DcXhZ17ZvPFCFRtNv3piSNY';

/**
 * Sometimes service worker expires so we restart it each time on page open to make sure it's working every time
 */
function restartExistingServiceWorker() {
    try {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    if (registration.scope.includes('firebase-cloud-messaging-push-scope')) {
                        // TODO: this works in Chrome only, how to make it working in other browsers?
                        (registration as any).sync?.register?.({});
                    }
                }
            });
        }
    } catch (error) {
        logger.error({category: logger.category.Notification, message: 'Failed to restart fcm service worker'}, error);
    }
}

let messaging = null;
/**
 * Initial service worker subscription works incorrectly in firebase backend and produces a warning in a console:
 * FirebaseError: Messaging: A problem occurred while unsubscribing the user from FCM: Requested entity was not found.
 *
 * Follow the next topic for the fix:
 * https://github.com/firebase/firebase-js-sdk/issues/2364
 */
function initialize() {
    restartExistingServiceWorker();
    messaging = getMessaging(initializeApp(config));
}

export const firebase = {
    initialize,
    isSupported,
    getToken: () => messaging ? getToken(messaging, {vapidKey}) : Promise.reject('"messaging" is not initialized'),
    deleteToken: () => messaging ? deleteToken(messaging) : Promise.resolve(false)
};
